import LazyLoad from "react-lazyload";

import dynamic from "next/dynamic";

import Img from "components/atoms/Img";
import Title from "components/atoms/Title";
import Toast from "components/atoms/Toast";
import Banner from "components/organisms/Banner";
import Faqs from "components/organisms/Faqs";
import HowItWorks from "components/organisms/HowItWorks";

import FormCheckNameCompany from "../components-tool/FormCheckNameCompany";
const NewsSlider = dynamic(() => import("components/organisms/NewsSlider"), {
  ssr: false,
});

/** ********/

const EntityNameCheck = ({ dataJson, data }) => {
  return (
    <>
      <section>
        <Banner
          breadcrumbs={dataJson?.breadcrumbs}
          title={dataJson?.banner?.title}
          titleProps={{
            className: "banner-default-title mb-6",
            textColor: "banner-title-default-color",
          }}
          leftClassName="lg:col-6"
          rightClassName="lg:col-6"
          rightContent={
            <Img
              src="/assets/images/offshore/guide-and-tool/banner_name_check-offshore-tools.png"
              className="h-full w-full"
              wrapper={{
                className:
                  "bbc-banner-image-country pb-10 lg:pb-0 banner-lg-max-w-500",
              }}
              width={594}
              height={444}
              alt="banner-img"
            />
          }
          bgColor="bg-bbc-country"
        ></Banner>
      </section>
      <section>
        <div className="container">
          <div className="row">
            <div className="mb-10 lg:col-4 lg:mb-0">
              <Title className="title-h2 mb-9 text-bbc-brand-800 lg:mb-10">
                Check Your Business Name For Free
              </Title>
              <p>
                If you&lsquo;re looking for registering a business, picking an
                eligible name is a must. Free Entity Name Check allows you to
                check the availability of your desired business name with no
                cost!
              </p>
            </div>
            <div className="lg:col-8">
              <Toast>
                <FormCheckNameCompany data={data.countries} />
              </Toast>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          <Title className="title-h2 mb-9 text-bbc-brand-800 lg:mb-10">
            Let Us Cover Your Need
          </Title>
          <div>
            <p>
              We&lsquo;ve made it simple to find out your unique name!
              <br />
              What you need to do is just to complete the form with a few pieces
              of information. Please feel secured as we keep all of your
              information private. We will then check if it is available to
              reserve or already in use and inform you shortly.
            </p>
          </div>
        </div>
      </section>
      <section>
        <HowItWorks data={dataJson?.dataHowItWork} className="mb-10 lg:mb-20">
          <Title className="text-center font-semibold lg:text-left">
            <span className="text-3xl text-bbc-brand-800 lg:block lg:text-bbc-40px">
              How{" "}
            </span>
            <span className="text-3xl text-bbc-brand-800 lg:block lg:text-4xl lg:leading-[44px] lg:text-bbc-brand-600">
              It Works ?
            </span>
          </Title>
        </HowItWorks>
      </section>
      <section>
        <div className="container">
          <div className="lg:col-10 lg:m-auto">
            <Faqs
              data={dataJson.dataFaqs}
              description="Know more about our nominee service with commonly asked questions."
            />
          </div>
        </div>
      </section>
      <section className="mb-0">
        <div className="container">
          <Title className="title-h2 m-auto mb-10 w-2/3 pb-0 text-center text-bbc-brand-800">
            Industry News & Insights
          </Title>
          <LazyLoad>
            <NewsSlider data={data} />
          </LazyLoad>
        </div>
      </section>
    </>
  );
};

export default EntityNameCheck;
